import React from 'react';

import Modal from 'components/core/Modal';

import MediaGrid from 'components/MediaGrid';

import { TMediaItem, TMediaType } from 'api/media';

type TMediaPickerModalProps = {
  isOpen: boolean;
  mediaTypes?: TMediaType[];
  onClose: () => void;
  onSelect: (url: string, mediaType: TMediaType, mediaId: string) => void;
};

const MediaPickerModal = ({ isOpen, mediaTypes, onClose, onSelect }: TMediaPickerModalProps) => {
  const handleSelect = (item: TMediaItem) => {
    onSelect(item.mediaUrl, item.mediaType, item.id);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Choose from Assets" width={520}>
      <MediaGrid mediaTypes={mediaTypes} onSelect={handleSelect} />
    </Modal>
  );
};

export default MediaPickerModal;
